(function (window) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', launchSplides);
  } else {
    launchSplides();
  }

  document.addEventListener('shopify:section:load', launchSplides);

  function launchSplides(e) {
    if (typeof window.splideStarters !== 'undefined' && Array.isArray(window.splideStarters)) {
      splideStarters.forEach((ss, idx) => {
        splideStarters[i] = ss();
      });
    }

    // A - Logo tickers

    let splideShows;
    if (e?.srcElement) {
      splideShows = e?.srcElement.querySelectorAll('.splide-logo-ticker');
    } else {
      splideShows = document.getElementsByClassName('splide-logo-ticker');
    }
    for (let i = 0; i < splideShows.length; i++) {
      const show = new Splide(splideShows[i], {
        type: 'loop',
        drag: 'free',
        focus: 'center',
        pagination: false,
        gap: '6vh',
        // clones: 8,
        arrows: false,
        autoWidth: true,
        autoScroll: {
          speed: parseFloat(splideShows[i].dataset.speed),
          pauseOnHover: false,
          pauseOnFocus: false,
        },
        intersection: {
          inView: {
            autoScroll: true,
          },
          outView: {
            autoScroll: false,
          },
        },
        breakpoints: {
          630: {
            gap: '6vh',
          },
        },
      }).mount(window.splide.Extensions);

      // Listen for FPS announcement to adjust speed based on device refresh rate
      document.addEventListener('fpsCheck', (e) => {
        show.options = { autoScroll: { speed: (show.options.autoScroll.speed * 144) / e.detail } };
      });

      // Could associate the splide object with the DOM element
      // splideShows[i].dataset.splideShow = show;
    }

    // A2 - Photo Carousel

    if (e?.srcElement) {
      splideShows = e?.srcElement.querySelectorAll('.splide-photo-carousel');
    } else {
      splideShows = document.getElementsByClassName('splide-photo-carousel');
    }
    for (let i = 0; i < splideShows.length; i++) {
      const show = new Splide(splideShows[i], {
        type: 'loop',
        drag: 'free',
        focus: 'center',
        pagination: false,
        // gap: '3vh',
        // clones: 8,
        arrows: false,
        autoWidth: true,
        autoScroll: {
          speed: parseFloat(splideShows[i].dataset.speed),
        },
        intersection: {
          inView: {
            autoScroll: true,
          },
          outView: {
            autoScroll: false,
          },
        },
        breakpoints: {
          630: {
            // gap: '3vh',
          },
        },
      }).mount(window.splide.Extensions);

      // Listen for FPS announcement to adjust speed based on device refresh rate
      document.addEventListener('fpsCheck', (e) => {
        show.options = { autoScroll: { speed: (show.options.autoScroll.speed * 144) / e.detail } };
      });

      // Could associate the splide object with the DOM element
      // splideShows[i].dataset.splideShow = show;
    }

    // B - Marquees

    if (e?.srcElement) {
      splideShows = e?.srcElement.querySelectorAll('.splide-marquee');
    } else {
      splideShows = document.getElementsByClassName('splide-marquee');
    }
    for (let i = 0; i < splideShows.length; i++) {
      const show = new Splide(splideShows[i], {
        type: 'loop',
        drag: false,
        focus: 'center',
        pagination: false,
        gap: '3vh',
        clones: 20,
        arrows: false,
        autoWidth: true,
        autoScroll: {
          speed: parseFloat(splideShows[i].dataset.speed),
          pauseOnHover: false,
          pauseOnFocus: false,
        },
        intersection: {
          inView: {
            autoScroll: true,
          },
          outView: {
            autoScroll: false,
          },
        },
        breakpoints: {
          630: {
            gap: '3vh',
          },
        },
      }).mount(window.splide.Extensions);

      // Listen for FPS announcement to adjust speed based on device refresh rate
      document.addEventListener('fpsCheck', (e) => {
        show.options = { autoScroll: { speed: (show.options.autoScroll.speed * 144) / e.detail } };
      });
    }
  }
})(window);

document.addEventListener('DOMContentLoaded', function () {
  var elms;

  // A - Product Carousel
  elms = document.getElementsByClassName('product-gallery');
  for (var i = 0; i < elms.length; i++) {
    const pc = new Splide(elms[i], {
      // arrowPath: 'm14,35V5l15,15-15,15Z',
      type: 'loop',
      updateOnMove: true,
      padding: '20%',
      focus: 'center',
      gap: '3%',
      autoWidth: true,
    }).mount();

    pc.on('click', function (slide, e) {
      // listen for "click" event: fired when the user clicks any slide
      if (pc.index != slide.index) {
        e.preventDefault();
        pc.go(slide.index); // apply "go" method: slide to the index of the clicked slide (component)
      }
    });
  }

  // B - Testimonial Carousel
  elms = document.getElementsByClassName('testimonial-gallery');
  for (var i = 0; i < elms.length; i++) {
    const pc = new Splide(elms[i], {
      type: 'loop',
      // width: '100%',
      // This is important because it's a child of a flex object,
      // so width isn't being constrained naturally.
      // Well, it *would* be important if this were indeed the child
      // element, but there's a parent container element that needs
      // to be set to 100% with instead.
      updateOnMove: true,
    }).mount();
  }

  // C - Review Carousel
  elms = document.getElementsByClassName('review-gallery');
  for (var i = 0; i < elms.length; i++) {
    const pc = new Splide(elms[i], {
      type: 'loop',
      // perPage: 3,
      fixedWidth: 400,
      flickPower: 150,
      perMove: 1,
      gap: '3%',
      focus: 'center',
      updateOnMove: true,
      breakpoints: {
        630: {
          fixedWidth: false,
          gap: '8%',
          padding: '10%',
        },
      },
    }).mount();

    pc.on('click', function (slide, e) {
      // listen for "click" event: fired when the user clicks any slide
      if (pc.index != slide.index) {
        e.preventDefault();
        pc.go(slide.index); // apply "go" method: slide to the index of the clicked slide (component)
      }
    });
  }

  // D - Diagram Carousel
  elms = document.getElementsByClassName('diagram-gallery');
  for (var i = 0; i < elms.length; i++) {
    const pc = new Splide(elms[i], {
      type: 'loop',
      updateOnMove: true,
    }).mount();
  }

  // E - Hero Carousel
  elms = document.getElementsByClassName('hero-gallery');
  for (var i = 0; i < elms.length; i++) {
    const pc = new Splide(elms[i], {
      type: 'fade',
      autoplay: true,
      interval: 3000,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      pagination: false,
    }).mount();

    pc.on('dragged', function (newIndex, prevIndex, destIndex, source) {
      console.log('drag');
      pc.Components.Autoplay.pause(); // Stop autoplay when a slide is manually navigated
    });

    elms[i].querySelectorAll('button').forEach((b) => {
      b.addEventListener('click', (e) => {
        pc.Components.Autoplay.pause();
      });
    });
  }
});
